// host.js - Which of the two sites this browser tab is. One build serves both
// hostnames, so the hostname is the only thing that tells them apart.
//
//   internationalgoldandsilver.com        the customer site
//   admin.internationalgoldandsilver.com  the dashboard
//
// The real redirect happens in index.html, before React loads, so the admin
// subdomain never flashes the marketing page. This module is what the app itself
// uses once it is running.
//
// LEGEND
//   1. isAdminHost()  true on the admin subdomain
//   2. siteOrigin()   where the customer site lives, for links out of the dashboard
//   3. adminOrigin()  where the dashboard lives, for links into it

const ADMIN_LABEL = "admin";

////////// 1. WHICH SITE //////////
// False during prerendering, because there is no window and the static HTML we
// generate is always the customer site.

export function isAdminHost() {
  if (typeof window === "undefined") return false;
  return window.location.hostname.split(".")[0] === ADMIN_LABEL;
}

////////// 2. THE CUSTOMER SITE //////////
// On the admin subdomain a link to "/" would bounce straight back to the
// dashboard, so anything pointing at the customer site needs the full origin.

export function siteOrigin() {
  const configured = import.meta.env?.VITE_SITE_URL;
  if (configured) return configured.replace(/\/$/, "");

  if (typeof window === "undefined") return "";
  const { protocol, host } = window.location;
  return isAdminHost()
    ? `${protocol}//${host.split(".").slice(1).join(".")}`
    : `${protocol}//${host}`;
}

////////// 3. THE DASHBOARD //////////

export function adminOrigin() {
  if (typeof window === "undefined") return "";
  const { protocol, host } = window.location;
  return isAdminHost() ? `${protocol}//${host}` : `${protocol}//${ADMIN_LABEL}.${host}`;
}
